<template>
  <b-form-select
    v-if="!isBusy"
    v-bind="$attrs"
    :options="options"
    @change="recordTicketCollector"
    v-model="selectedTicketCollector"
    style="min-width: 130px;"
    class="form-control"
  >
    <template #first>
      <b-form-select-option :value="null">
        Cobrador
      </b-form-select-option>
    </template>
  </b-form-select>
  <b-skeleton v-else animation="wave" style="min-width: 100px;" />
</template>

<script>
import { Api } from '../../../../vue/api';
const API = new Api();

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    invoiceId: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  data() {
    return {
      selectedTicketCollector: this.value,
      options: [
        { value: 'André', text: 'André' },
        { value: 'Veins', text: 'Veins' },
      ],
      isBusy: false,
    };
  },
  methods: {
    async recordTicketCollector() {
      this.isBusy = true;
      /** @type {{ok: boolean, errors: Object}} */
      const { ok, errors } = await API.post('/execute', {
        path: `/invoice/record-ticket-collector/${this.invoiceId}`,
        method: 'post',
        data: { responsible: this.selectedTicketCollector },
      });
      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        this.isBusy = false;
        return;
      }
      this.$bvToast.toast('Responsável atualizado com sucesso!', {
        title: `Sucesso`,
        variant: 'success',
        solid: true,
      });
      this.isBusy = false;
    },
  },
};
</script>
